import { RequestHelper } from "../Helpers/RequestHelper.js";

export class PmApiDtm {
    constructor(config) {
        this.config = config;
    }

    getRootURL() {
        if (this.config.production) {
            return "https://api.dtm.pixelmotiondemo.com/";
        }
        if (this.config.dev) {
            return "http://localhost:3000/";
        }
        return "http://pmm-api.loc/";
    }

    getURL() {
        return this.getRootURL() + "api/v1/";
    }

    // VIN DECODE FOR FCA
    getMakeFCA(year, successCallback, errorCallback) {
        // https://api.dtm.pixelmotiondemo.com/api/v1/chromeMakesByYear/2024
        // let route = this.getURL() + "chromeMakesByYear/" + year;
        let route = "https://api.dtm.pixelmotiondemo.com/api/v1/chromeMakesByYear/" + year;
        RequestHelper.ajax("GET", route, {}, successCallback, errorCallback);
    }

    getModeslFCA(year, modelId, successCallback, errorCallback) {
        // https://api.dtm.pixelmotiondemo.com/api/v1/chromeModelsByDivisionIdYear/2024/9
        // let route = this.getURL() + "/chromeModelsByDivisionIdYear/" + year + "/" + yearId;
        let route = "https://api.dtm.pixelmotiondemo.com/api/v1/chromeModelsByDivisionIdYear/" + year + "/" + modelId;
        RequestHelper.ajax("GET", route, {}, successCallback, errorCallback);
    }

    getTrimsFCA(year, make, model, successCallback, errorCallback) {
        // https://api.dtm.pixelmotiondemo.com/api/v1/chromeTrimsByMakeModelYear/2024/Chrysler/Pacifica
        let route = "https://api.dtm.pixelmotiondemo.com/api/v1/chromeTrimsByMakeModelYear/" + year + "/" + make + "/" + model;
        RequestHelper.ajax("GET", route, {}, successCallback, errorCallback);
    }
    // END VIN DECODE FOR FCA

    // Method to save the DRS Lead
    postLead(data, successCallback, errorCallback) {
        let url = this.getURL() + "lead/save/drs";
        this.getIPAddress(
            (response) => {
                let ip = response
                    .split("\n")
                    .filter((el) => el.startsWith("ip"))
                    .join("\n");
                data.set("ip", ip.substring(3));
                RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
            },
            (error) => {
                data.set("ip", "");
            }
        );
    }

    // Method to save the Schedule Test Ride Lead
    postNoDRSLead(data, successCallback, errorCallback) {
        let url = this.getURL() + "lead/save";
        this.getIPAddress(
            (response) => {
                let ip = response
                    .split("\n")
                    .filter((el) => el.startsWith("ip"))
                    .join("\n");
                let entry = JSON.parse(data.get("entry"));
                entry.ip = ip.substring(3);
                data.set("entry", JSON.stringify(entry));
                RequestHelper.ajax("POST", url, data, successCallback, errorCallback);
            },
            (error) => {
                data.set("ip", "");
            }
        );
    }

    // Method to save the Schedule Test Ride Lead
    postChatLead(formData, successCallback, errorCallback) {
        var $this = this;
        let url = this.getURL() + "lead/save/chat";
        this.getIPAddress(
            (response) => {                
                const ip = $this.getIpFromResponse(response);
                formData.set("ip", ip);
                RequestHelper.ajax("POST", url, formData, successCallback, errorCallback);
            },
            (error) => {
                data.set("ip", "");
            }
        );
    }

    getIpFromResponse(cloudFlareReponse){
        let ip = cloudFlareReponse
                .split("\n")
                .filter((el) => el.startsWith("ip"))
                .join("\n");
        return ip.substring(3);
    }

    // Method for getting the client ip
    getIPAddress(successCallback, errorCallback) {
        const CLOUDFLARE = "https://www.cloudflare.com/cdn-cgi/trace";
        RequestHelper.ajax("GET", CLOUDFLARE, {}, successCallback, errorCallback);
    }

    // function to vin decode for OEM=GENESIS vehicles
    decodeByVin(data, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "chromedatavin/" + data.siteToken + "/" + data.vin,
            {},
            successCallback,
            errorCallback
        );
    }

    // function to vin decode using fullDecode api.dtm endpoint
    fullDecode(data, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "fullDecode/" + data.vin,
            {},
            successCallback,
            errorCallback
        );
    }

    getVinDecode(data, successCallback, errorCallback) {
        RequestHelper.ajax("GET", this.getURL() + "PMVINDecode/nhtsa/" + data.vin, {}, successCallback, errorCallback);
    }

    getDealerProfileSettings(data, successCallback, errorCallback) {
        RequestHelper.ajax(
            "GET",
            this.getURL() + "dealerprofile/settings/" + data.siteToken,
            {},
            successCallback,
            errorCallback
        );
    }
}
